import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  // Constuctor
  constructor(
    private router: Router) {

  }

  ngOnInit(): void {
    alert(123);
    this.router.navigate(["/live"]);      
  }
}
